<template>
	<div class="addressBar">
		<!-- <p class="PL fl"><a href="">{{addressBarData.lanmu.Name}}</a></p> -->
		<p class="PR">当前位置：
			<router-link to="./" >首页 >>&nbsp;</router-link>
			<!-- <router-link v-if="addressBarData.PColumn" :href="addressBarData.PColumn.Url" :to="addressBarData.PColumn.Url"  @click.native="OpenLink(item.Url)">{{addressBarData.PColumn.Name}} >>&nbsp;</router-link> -->
			<router-link :to="addressBarData.lanmu.Url"  :href="addressBarData.lanmu.Url"  @click.native="OpenLink(addressBarData.lanmu.Url)" >{{addressBarData.lanmu.Name}}</router-link>
		</p>
	</div>
</template>

<script>
	export default{
		name:'addressBar',
		props:{
			addressBarData:{
				type: Object,
				  default: () => {
					  return {
						PColumn:{},
						lanmu:{},
						List:[]
					  }
				  }
			},
			moreLink: {
			   type: String,
			   default: ''
			 }
		}
	}
</script>

<style lang="less" scoped="scoped">
	.addressBar{
    height: 0.6rem;
    padding-left: 0.40rem;
    position: relative;
    box-shadow: 0rem 0rem 0.16rem 0rem rgb(107 107 107 / 10%);
      .PR{
        font-size: 0.22rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.6rem;
        letter-spacing: 0rem;
        color: #333333;
      }
      &::before {
        content: '';
        width: 0.06rem;
        height: 0.22rem;
        background-color: #0376be;
        border-radius: 0.03rem;
        position: absolute;
        left: 0.27rem;
        top: 0.18rem;
    }
	}
</style>



// WEBPACK FOOTER //
// src/components/addressBar.vue